// GraphQL fragments for chat-related queries
import { MEDIA_FRAGMENT } from './common';

// Basic field selections for Message type
export const MESSAGE_FIELDS_FRAGMENT = `
  id
  content
  status
  createdAt
  updatedAt
`;

// Basic field selections for User/Sender type
export const SENDER_FIELDS_FRAGMENT = `
  id
  name
  avatar
`;

// Basic field selections for Customer type
export const CUSTOMER_FIELDS_FRAGMENT = `
  id
  name
  email
  phone
  avatar {
    ${MEDIA_FRAGMENT}
  }
`;

// Basic field selections for Shop type in chat context
export const SHOP_FIELDS_FRAGMENT = `
  id
  name
  avatar {
    ${MEDIA_FRAGMENT}
  }
`;

// Extended shop fields for chat rooms
export const CHAT_ROOM_SHOP_FRAGMENT = `
  id
  name
  streetAddress
  displayedAddress
  phone
  avatar {
    ${MEDIA_FRAGMENT}
  }
`;

// Basic field selections for ChatRoom type
export const CHAT_ROOM_FIELDS_FRAGMENT = `
  id
  customer {
    id
    name
    email
    phone
  }
  shop {
    ${CHAT_ROOM_SHOP_FRAGMENT}
  }
  type
  status
  lastMessage
  lastMessageAt
  unreadCount {
    customer
    shop
  }
  createdAt
  updatedAt
`;

// Simplified fragment for initializeOrGetChatRoom response
// This mutation returns customer and shop as string IDs, not objects
export const CHAT_ROOM_INIT_FRAGMENT = `
  id
  customer
  shop
  type
  status
  lastMessage
  lastMessageAt
  createdAt
  updatedAt
`;

// Composite fragment for Message with nested Sender (for queries)
export const MESSAGE_WITH_SENDER_FRAGMENT = `
  ${MESSAGE_FIELDS_FRAGMENT}
  sender {
    ${SENDER_FIELDS_FRAGMENT}
  }
`;

// Fragment for sendMessage mutation response
export const MESSAGE_MUTATION_RESPONSE_FRAGMENT = `
  id
  content
  status
  createdAt
  updatedAt
  sender {
    id
    name
    avatar
  }
`;